export default "__VITE_ASSET__BqG14hOM__"